import { useNavigate } from "react-router-dom";
import { useAssistantChat } from "@/app/hooks/useAssistantChat";
import { InitialView } from "@/app/components/assistant/InitialView";
import { ChatView } from "@/app/components/assistant/ChatView";
import type { AuditFlowMessage } from "@/app/components/shared/types";

export default function AssistantPage() {
    const navigate = useNavigate();
    const { messages, isResponseLoading, handleChat, handleNewChat, cancel } =
        useAssistantChat();

    async function handleInitialSubmit(message: AuditFlowMessage) {
        const chatId = await handleNewChat(message);
        if (chatId) navigate(`/assistant/chat/${chatId}`);
    }

    if (messages.length === 0) {
        return (
            <InitialView
                onSubmit={(message) => void handleInitialSubmit(message)}
            />
        );
    }

    return (
        <ChatView
            messages={messages}
            isResponseLoading={isResponseLoading}
            handleChat={handleChat}
            cancel={cancel}
        />
    );
}
